import * as Constantes from '../../../shared/constants';

import { OnDestroy } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { Subscription, delay } from 'rxjs';

//Modelos e Interfaces
import { IArticulo } from 'src/app/interfaces/articulo';
import { ICliente } from 'src/app/interfaces/cliente';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';
import { IPedidoExternoDetall } from 'src/app/interfaces/pedido_externo';

// Servicios
import { PedidosExternosService } from 'src/app/services/datos/pedidosExternos.service';
import { ArticulosService } from 'src/app/services/datos/articulos.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { ModalImagenService } from 'src/app/services/modal-imagen.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { EanLabelsService } from 'src/app/services/ean-labels.service';

// Librerias
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import FuncLib from 'src/app/providers/funcionesLib';

interface Editing {
  [key: string]: boolean;
}

@Component({
  selector: 'app-articulos-lista',
  templateUrl: './articulos-lista.component.html',
  styleUrls: ['./articulos-lista.component.scss'],
})
export class ArticulosListaComponent implements OnInit, OnDestroy {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  // Usar constantes en el template
  Constantes = Constantes;

  parametrosUrl: any; // Parámetro desde CampanyaNueva.Component

  loading: boolean = false;
  public fotoDir: string = environment.fotoDir;
  public imgSubs: Subscription | undefined;

  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado',
  };

  articulosList: IArticulo[] = [];
  clientesList: ICliente[] = [];

  rows: IArticulo[] = [];
  temp: any[] = [];

  columns = [];
  ColumnMode = ColumnMode;

  opcionesList: IListaOpciones = {};
  cliSeleccionado: string = '';

  editing: Editing = {};

  articuloExterno: IPedidoExternoDetall = {};

  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';


  // Cargar más
  public mostrarCargaMas: boolean = true; // si activamos un filtro, se desactiva el botón de cargar más
  concatData: boolean = false;
  recDesde: number = 0; // Desde dónde cargar
  recCuantos: number = parseInt(
    localStorage.getItem('recCuantosArticulos') || '1000'
  ); // Cuantos cargar
  recTotal: number = 0; // Total de registros


  @ViewChild(ArticulosListaComponent) table: ArticulosListaComponent | any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public articulosSrv: ArticulosService,
    private notifSrv: NotificacionesService,
    private modalImagenSrv: ModalImagenService,
    private clientesSrv: ClientesService,
    private pedidosExternosSrv: PedidosExternosService,
    public eanLabelsSrv: EanLabelsService
  ) { }

  ngOnDestroy(): void {
    this.imgSubs?.unsubscribe();
  }

  ngOnInit(): void {
    // Mirar si pasan parámetros
    this.route.queryParams.subscribe((params) => {
      this.parametrosUrl = params || {};

      console.log('_recibido parametrosUrl:', this.parametrosUrl);
      if (this.parametrosUrl.id_cliente)
        this.cliSeleccionado = this.parametrosUrl.id_cliente;
      if (this.parametrosUrl.articuloExterno_id) {
        this.cargarArticuloExterno();
      } else {
        this.articuloExterno = {};
      }
    });

    this.getClientesList();
    this.getListaArtic();

    // Nos suscribimos a la imagen,
    // Si cambia la imagen, buscamos esa id en this.lista[]

    this.imgSubs = this.modalImagenSrv.nuevaImagen
      .pipe(delay(100))
      .subscribe((img) => {
        const indice = this.articulosList.findIndex((art) => art.id === img.id);
        this.articulosList[indice].foto = img.guardado_como;
      });
  }

  getListaArtic() {
    this.opcionesList = {};
    this.opcionesList.recDesde = this.recDesde;
    this.opcionesList.recCuantos = this.recCuantos;
    if (this.cliSeleccionado) this.opcionesList.id_cliente = parseInt(this.cliSeleccionado);

    this.loading = true;
    this.articulosSrv.getListaFiltrada(this.opcionesList).subscribe((resp) => {
      this.loading = false;

      this.limpiaBusca();
      if (resp.error) {
        this.notifSrv.aviso('error', resp.mensaje);
        return;
      }

      this.recTotal = parseInt(resp.totales.totalRegistros);

      if (this.concatData) {
        this.articulosList = this.articulosList.concat(resp.data);
      } else {
        this.articulosList = resp.data;
      }
      this.concatData = false;

      console.log('__getListaPedidos() recDesde: ', this.recDesde);
      console.log('__getListaPedidos() recTotal: ', this.recTotal);

      this.rows = this.articulosList;
      this.temp = [...this.articulosList];
    });
  }


  cargaMas() {
    this.concatData = true;
    this.recDesde += this.recCuantos;
    if (this.recDesde > this.recTotal) this.recDesde = this.recTotal;

    console.log('__cargaMas() recDesde: ', this.recDesde);
    console.log('__cargaMas() recCuantos: ', this.recCuantos);
    console.log('__cargaMas() recTotal: ', this.recTotal);

    this.getListaArtic();
  }


  getClientesList() {
    this.clientesSrv.getLista().subscribe((resp) => {
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  // Búscar y filtrar

  filtro(val: string, campo: string) {
    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d[campo]) return d[campo].toLowerCase().indexOf(val) !== -1 || !val;
      return !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.articulosList;
  }

  buscar(event: any, campo: string) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.filtro(txt, campo);
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.articulosList;
  }

  dblclickCampo(valor: any) {
    this.strBuscarTodo = String(valor);
    const txt = valor.toLowerCase() ?? '';
    this.buscaGlobal(txt);
  }

  buscaGlobal(txt: string) {
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.articulosList;
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscaGlobal('');
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr);
  }

  // Filtros

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.recDesde = 0;
    this.getListaArtic();
    this.limpiaBusca();
  }

  //  CRUD  //

  editRow(row: IArticulo) {
    this.notifSrv.aviso('info', `editar id ${row.id}`);
  }

  deleteRow(row: any) {
    Swal.fire({
      title: '¿Borrar artículo?',
      icon: 'question',
      html: `Eliminar <b>${row.descripcion}</b>`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.articulosSrv.delete(row.id).subscribe((resp) => {
          if (resp.error) {
            this.notifSrv.aviso('error', resp.mensaje);
          } else {
            this.notifSrv.aviso('info', `Registro eliminado`);
            this.rows = this.rows.filter((objeto) => objeto.id !== row.id);
          }
        });
      }
    });
  }

  archivarClick(row: IArticulo) {
    Swal.fire({
      title: '¿Mover a histórico?',
      icon: 'question',
      html: `El artículo se archivará y dejará de estar disponible`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.articulosSrv.archivar(row.id!).subscribe((resp) => {
          console.log('__archivarClick()', resp);
          this.loading = false;
          if (resp.error) {
            this.notifSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notifSrv.aviso(
            'info',
            `Articulo ${row.ean} movido a histórico`
          );
          this.router.navigateByUrl(`panel/articulos_lista`);
        });
      }
    });
  }

  // AUX  //

  // Cargar Detall de un Pedido Externo
  cargarArticuloExterno() {
    this.loading = true;
    this.pedidosExternosSrv
      .getPedidoEDetall(this.parametrosUrl.articuloExterno_id)
      .subscribe((resp) => {
        this.loading = false;
        console.log('__cargarArticuloExterno()', resp);
        if (resp.error) {
          this.notifSrv.aviso('error', resp.mensaje);
          this.router.navigate(['/panel/campanya_new']);
          return;
        }
        this.articuloExterno = resp.data;
      });
  }

  // Cambiar el articulo del pedidoExternoDetall por el seleccionado de la lista
  cambiaArticulo(row: IArticulo) {
    console.log('__articuloExterno', this.articuloExterno);

    Swal.fire({
      title: '¿Cambiar artículo?',
      icon: 'question',
      html: `Pedido <b><span class="text-info">${this.articuloExterno.pedido_cli
        }</span></b><br>
    <br>
    Sustituir: <b>${this.articuloExterno.ean}</b> - ${this.articuloExterno.sku
        }<br>
    ${this.articuloExterno.descripcion}
    <hr>
    Por: <b>${row.ean}</b> - ${row.sku} <br>
    ${row.descripcion}
    <br>
    <br>
    <h1> Stock: ${row.artStock!.toLocaleString('de-DE')}</h1>

        <img src="${this.fotoDir}/articulos${this.imgResized}${row.foto}"
              loading="lazy"
              class="rounded border p-1"
              height="55px"
              alt="Foto"
              title="Foto">

    `,
      showCancelButton: true,
      //  showDenyButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: `Sí, para el pedido <b>${this.articuloExterno.pedido_cli}</b>`,
      denyButtonText: 'Sí, para todos los pedidos pendientes',
      customClass: {
        denyButton: 'btn btn-info btn-block m-2',
        confirmButton: 'btn btn-info btn-block m-2',
        cancelButton: 'btn btn-secondary   m-2',
      },
      buttonsStyling: false, // Desactiva los estilos por defecto de SweetAlert2
    }).then((result) => {
      if (result.isConfirmed || result.isDenied) {
        const data = {
          id_inicial: this.articuloExterno.id!,
          id_articulo: row.id!,
          todos: result.isDenied ? 'S' : 'N',
        };

        console.log('__cambiaArticulo() data', data);
        this.pedidosExternosSrv.cambiaPedido(data).subscribe((resp) => {
          console.log('__cambiaArticulo() resp', resp);
          if (resp.error) {
            this.notifSrv.aviso('error', resp.mensaje);
            return;
          } else {
            this.notifSrv.aviso('info', resp.mensaje);
            this.router.navigate(['/panel/campanya_new']);
            return;
          }
        });
      }
    });
  }

  // Abrir modal imagen
  abrirModal(row: IArticulo) {
    this.modalImagenSrv.abrirModal('articulos', row.id!.toString(), row.foto);
  }

  // EXPORTAR A EXCEL
  exportToExcel(): void {
    const fileName = `articulos-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }
}
